export default __webpack_public_path__ + "static/media/search-up-select.64bfc67b.svg";